
import { InvoiceDetail, SttInvoice } from '@/domain/entities/PrintReceipt';
import { Options, prop, Vue } from 'vue-class-component';
import html2canvas from 'html2canvas';
import JSPDF from "jspdf";
import { MainAppController } from '@/app/ui/controllers/MainAppController';
import formatPrice from '@/app/infrastructures/misc/common-library/v2/FormatPrice';
import formatDateBasedTimezoneValue from '@/app/infrastructures/misc/common-library/v2/FormatDateBasedTimezoneValue';
import { AccountController } from '@/app/ui/controllers/AccountController';

class Props {
  invoiceData = prop<InvoiceDetail>({
    default: () => new InvoiceDetail(),
    type: Object
  });
  items = prop<SttInvoice[]>({
    default: () => [],
    type: Object
  });
}

@Options({})
class InvoicePdfStruk extends Vue.with(Props) {
  get accountCurrency() {
    return (
      (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ?? "IDR"
    );
  }
  formatDateWithTz(date: any, format: string) {
    return formatDateBasedTimezoneValue(date, format);
  }
  formatPriceAmount(amount: number) {
    return formatPrice(amount, "", this.accountCurrency as "IDR" | "MYR");
  }
  show = false;

  async generatePdfStruk() {
    this.show = true;
    MainAppController.showLoading();
    await this.$nextTick();
    const element = document.getElementById("invoice-pdf-struk")!;
    const originalDisplay = element.style.display;

    element.style.display = "block";
    element.style.position = "absolute";
    element.style.left = "-99999px"

    const style = document.createElement('style');
    document.head.appendChild(style);

    style.sheet?.insertRule('body > div:last-child img { display: inline-block; }');

    const canvas = await html2canvas(element, {scale: 2, width: 360});
    const imgWidth = 80; // mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const pdf = new JSPDF("p", "mm", [imgWidth, imgHeight], true)

    style.remove();
    element.style.display = originalDisplay;
    element.style.position = '';
    element.style.left = '';

    const pdfWidth = pdf.internal.pageSize.getWidth(); // 80mm
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgData = canvas.toDataURL();

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

    const pdfBlob = pdf.output("blob");

    MainAppController.closeLoading();
    this.show = false;
    return pdfBlob as Blob;
  }

  async downloadPdfStruk() {
    const blob =  await this.generatePdfStruk();
    const blobUrl = URL.createObjectURL(blob);

    window.open(blobUrl)
  }

  maskSensitiveData(contact: string): string {
    if (!contact) return "";

    // Mask phone: 087***2738
    if (contact.length <= 6) {
      return contact;
    }
    const start = contact.substring(0, 3);
    const end = contact.substring(contact.length - 4);
    return `${start}***${end}`;
  }
}
export default InvoicePdfStruk;
